import { useForm } from "react-hook-form";

import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

import logoBranco from "../../../images/logoBranco.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Loading from "./../../../components/loading/loading";

import "./login-page.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import Swal from "sweetalert2";

import { FranchiseContext } from "../../../contexts/franchiseContext";

import { AuthUserContext } from "../../../contexts/authUserContext";

import { CartContext } from "../../../contexts/cartContext";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

const schema = yup.object().shape({
  email: yup
    .string()
    .required("O campo email é obrigatório.")
    .email("Email não aceito."),
  cpf: yup.string().required("O campo CPF é obrigatório."),
});

function LoginPage() {
  const [showNotSelectedFranchiseError, setShowNotSelectedFranchiseError] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [franchises, setFranchises] = useState([]);

  const { franchise, setFranchise } = useContext(FranchiseContext);

  const { setAuthUser } = useContext(AuthUserContext);

  const { removeAllCartItems } = useContext(CartContext);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    if (!franchise?.id) {
      setShowNotSelectedFranchiseError(true);
      return;
    }
    const payload = {
      email: data.email,
      password: data.cpf,
    };
    try {
      setLoading(true);
      const response = await api.post("login/client", payload);
      console.log("Response login", response);
      Toast.fire({
        icon: "success",
        title: `Login efetuado com sucesso!`,
      });
      const authUser = {
        ...response.data.user,
        telefone: response.data.user.phone,
        token: response.data.token.plainTextToken,
      };
      localStorage.setItem("authUser", JSON.stringify(authUser));
      removeAllCartItems();
      setAuthUser(authUser);
      const redirectUrl = searchParams.get("redirectUrl");
      if (redirectUrl) {
        navigate(redirectUrl);
      } else {
        navigate("/brinquedos-adoleta");
      }
      window.location.reload();
    } catch (error) {
      console.log("Error", error);
      Toast.fire({
        icon: "error",
        title: error.response.data.message,
      });
    } finally {
      setLoading(false);
      setShowNotSelectedFranchiseError(false);
    }
  };

  const getFranchises = async () => {
    api.get("franchises").then((response) => {
      setFranchises(response.data);
    });
  };

  useEffect(() => {
    setAuthUser({});
    setFranchise({});
    getFranchises();
    if (searchParams.get("showAlert")) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Você precisa realizar o login para acessar esta página",
      });
    }
  }, []);

  return (
    <div className="login-page">
      {loading ? <Loading /> : null}
      <div className="d-flex login-container">
        <div
          className="people-img"
          style={isMobile ? { display: "none" } : { display: "block" }}
        ></div>
        <div
          className={`login-content ${
            isMobile
              ? "mobile py-4 px-4"
              : "d-flex justify-content-center align-items-center py-5"
          }`}
        >
          <div className="d-flex flex-column justify-content-center login-form">
            <div className="w-100">
              <Link to={"/"}>
                <img src={logoBranco} alt="Bootstrap" width="280" height="45" />
              </Link>
            </div>
            <div className={`w-100 form-content ${isMobile ? "mobile" : ""}`}>
              <div className="titles">
                <h1
                  style={isMobile ? { fontSize: "32px" } : { fontSize: "48px" }}
                >
                  Entre na sua conta.
                </h1>
                <h4>
                  Informe seu e-mail e CPF para acessar sua conta Adoleta.
                </h4>
              </div>
              <form className="form" onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Seu e-mail
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    {...register("email")}
                    placeholder="Digite seu e-mail"
                  />
                  {errors.email ? (
                    <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-x-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                      <p>{errors.email.message}</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="cpf" className="form-label">
                    CPF
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    name="cpf"
                    id="cpf"
                    {...register("cpf")}
                    placeholder="Digite seu CPF"
                  />
                  {errors.cpf ? (
                    <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-x-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                      <p>{errors.cpf.message}</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 city-select">
                  <label htmlFor="franchise" className="form-label">
                    Franquia
                  </label>
                  <select
                    id="franchise"
                    className="form-select border-0 cities"
                    aria-label="Default select example"
                    onChange={(e) => {
                      const franchiseFound = franchises.find(
                        (f) => f.id == e.target.value
                      );
                      localStorage.setItem(
                        "franchise",
                        JSON.stringify(franchiseFound)
                      );
                      setFranchise(franchiseFound);
                    }}
                    defaultValue={0}
                  >
                    <option value="0">Selecione uma cidade</option>
                    {franchises.map((franchise) => (
                      <option value={franchise.id}>{franchise.name}</option>
                    ))}
                  </select>
                  {showNotSelectedFranchiseError ? (
                    <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-x-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                      <p>Por favor, selecione uma franquia</p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <button type="submit" className="btn w-100 button-submit">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-person"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                  </svg>
                  Login
                </button>
              </form>
              <div className="w-100 text-center not-acount">
                <h6 className="py-4">Não possui conta?</h6>
                <Link to={"/cadastro"} className="register">
                  Cadastre-se aqui!
                </Link>
              </div>
            </div>
            <div className="w-100 bottom-footer">
              <p className="d-flex align-items-center text-center">
                Adoleta Brinquedos LTDA | Copyright © 2022. Todos os Direitos
                Reservados
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
